import { Checkbox } from "@pepperstone/pepper-ui-kit";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  BaseModal,
  type BaseModalProps,
} from "@/components/general/base-modal/BaseModal";
import { BankTransferImportantNotes } from "./BankTransferImportantNotes";

export const BankTransferImportantNotesModal = ({
  onClose,
  onSubmit,
  ...props
}: Omit<BaseModalProps, "testId" | "children" | "onClose" | "onSubmit"> & {
  onClose: () => void;
  onSubmit?: (doNotShowAgain: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const handleSubmit = () => {
    onSubmit?.(doNotShowAgain);
    setDoNotShowAgain(false);
    onClose();
  };
  return (
    <BaseModal
      testId="bank-transfer-important-notes-modal"
      onClose={onClose}
      onSubmit={handleSubmit}
      title={t("deposit.bank_transfer_important_notes.title")}
      submitButtonContent={t("deposit.bank_transfer_important_notes.got_it")}
      {...props}
    >
      <BankTransferImportantNotes />
      <div style={{ marginBlockStart: "32px" }}>
        <Checkbox
          checked={doNotShowAgain}
          onChange={(e) => setDoNotShowAgain(e.target.checked)}
          id="bank_transfer_important_notes_dont_show_again"
          label={t("deposit.bank_transfer_important_notes.dont_show_again")}
        />
      </div>
    </BaseModal>
  );
};
